import * as React from 'react'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import { Box, Typography } from 'cs-kevlar-react'
import { N100 } from 'cs-kevlar-react/lib/es/theming/palette'
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    text: {
      color: N100,
    },
  }),
)

interface LicenseCountProps {
  availableLicenses: number
  totalLicenses: number | 'site'
  className?: string
}

export const LicenseCount: React.FunctionComponent<LicenseCountProps> = ({
  availableLicenses,
  totalLicenses,
  className,
}) => {
  const classes = useStyles({})

  return (
    <Typography variant="body1" className={clsx(classes.text, className)}>
      {availableLicenses} of {totalLicenses} licenses available
    </Typography>
  )
}
